module.exports = __webpack_public_path__ + "img/wufoo.6354f82d.png";